export const createPDPRedirectionUrl = (productId: string, productName: string): string => {
  const charsToRemove = /[<>#%{}^~[\];/?:@=&`\\|!*+'",.]/g;
  const formattedProductName = productName.replace(/\s+/g, '-');
  const filteredProductName = formattedProductName.replace(charsToRemove, '');
  return `/product/${filteredProductName}/${productId}`;
};

export function extractTextFromHTML(html: string) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
}
